var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 146,
    viewBox: "0 0 138 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.11328,
    y: 2.31738,
    width: 103.835,
    height: 114.636,
    rx: 6,
    stroke: "#003546",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1152,
    y: 24.4141,
    width: 51.5514,
    height: 12.8294,
    rx: 1,
    stroke: "#003546",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1152,
    y: 48.6357,
    width: 51.5514,
    height: 12.8294,
    rx: 1,
    stroke: "#003546",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7969,
    y: 30.7041,
    width: 13.1632,
    height: 4.1716,
    fill: "#003546"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7969,
    y: 54.9248,
    width: 13.1632,
    height: 4.1716,
    fill: "#003546"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7969,
    y: 75.2266,
    width: 57.8198,
    height: 4.1716,
    fill: "#003546"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.22,
    cy: 113.392,
    rx: 33.6668,
    ry: 32.4089,
    fill: "#97C33D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6189 116.352L96.9923 126.709L122.814 100.077",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSubmitted);
export default __webpack_public_path__ + "static/media/info-submitted.7715f7ff5224fcf60db452802ea7b60a.svg";
export { ForwardRef as ReactComponent };